import { TableLink } from "components/BaseTableV3/TableLink";
import CampaignService from "services/Campaign";
import {
  SessionSummary,
  StartDialSessionButton,
} from "routes/dial_sessions/components/SessionContacts";
import CONSTANTS from "constants/Constants";
import { DialSessionTableActions } from "./DialSessionTableActions";
import { Label } from "semantic-ui-react";

const statusOptions = Object.keys(CONSTANTS.STATUS_TYPES).map(key => ({
  id: CONSTANTS.STATUS_TYPES[key],
  name: key.charAt(0) + key.substring(1).toLowerCase(),
}));

export const getDialSessionTableColumns = ({
  temporaryDisabled,
  setTemporaryDisable,
}) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
    },
    {
      header: "Campaign Name & Session",
      id: "Campaign Name & Session",
      accessorKey: "name",
      enableSorting: false,
      cell: ({ row }) => (
        <div className="column-cell">
          <TableLink href={"/campaigns/" + row.original.campaign_id}>
            {row.original.campaign_name}
          </TableLink>
          <p>{row.original.name}</p>
        </div>
      ),
    },
    {
      header: "Status",
      id: "Status",
      size: 100,
      accessorKey: "status",
      cell: ({ row }) => (
        <Label
          color={row.original.status ? "green" : "red"}
          content={row.original.status ? "Active" : "Inactive"}
        />
      ),
    },
    {
      header: "Questionnaire",
      id: "Questionnaire",
      accessorKey: "form_url",
      cell: ({ row }) => (
        <a
          href={row.original.form_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.original.form_url}
        </a>
      ),
    },
    {
      header: "Contacts",
      id: "Contacts",
      accessorKey: "contacts",
      enableSorting: false,
      size: 420,
      minSize: 420,
      cell: ({ row }) => (
        <SessionSummary
          dialSessionId={row.original?.id}
          totalContacts={row.original?.summary_stats?.total_contacts}
          callableContacts={row.original?.summary_stats?.callable_contacts}
          urgentContacts={row.original?.summary_stats?.urgent_contacts}
          urgentCallableContacts={
            row.original?.summary_stats?.urgent_callable_contacts
          }
        />
      ),
    },
    {
      header: "Call",
      id: "Call",
      enableSorting: false,
      cell: ({ row }) => (
        <StartDialSessionButton
          id={row.original.id}
          callSessionsDisabled={!row.original.status || temporaryDisabled}
          setTemporaryDisable={setTemporaryDisable}
          callableContacts={row.original?.summary_stats?.callable_contacts}
        />
      ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      size: 260,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <DialSessionTableActions original={row.original} />,
    },
  ];
};

export const getDialSessionTableFilters = ({
  dialSessionOptions,
  questionnaireOptions,
}) => {
  return [
    {
      key: "campaign_id",
      title: "Campaign",
      type: "ruvixxSelect",
      queryFn: CampaignService.getCampaignsForFilters,
    },
    {
      key: "dial_session_id",
      title: "Dial Sessions",
      type: "select",
      data: dialSessionOptions,
    },
    {
      key: "form_id",
      title: "Questionnaire",
      type: "select",
      data: questionnaireOptions,
    },
    {
      key: "status",
      title: "Status",
      type: "select",
      data: statusOptions,
      isSingle: true,
    },
  ];
};
